<div class="saloons-page-container">
  <div class="header-section">
    <app-header [usePageBackground]="true"></app-header>
    <app-saloon-browse-toolbar></app-saloon-browse-toolbar>
  </div>
  <div class="content-wrapper">
    <router-outlet></router-outlet>
  </div>
  <app-navbar></app-navbar>
</div>
